/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import * as _ from 'lodash';
//import { saveSplunkLog } from '~/apps/shared/js/services/log-service';

export const trackPageView = function (analyticsInfo) {
  if (analyticsAvailable()) {
    getAnalyticsObjectByPage(analyticsInfo);
  }
};

export const trackEvent = function (analyticsInfo) {
  if (analyticsAvailable()) {
    getAnalyticsObjectByEvent(analyticsInfo, window.adobeAnalysticsObj);
  }
};

function analyticsAvailable() {
  return window.adobeAnalysticsObj !== undefined;
}

function getAnalyticsObjectByEvent(analyticsInfo) {
  const analyticsObject = window.adobeAnalysticsObj;
  analyticsObject.clearVars();

  if (_.has(analyticsInfo, 'event') && analyticsInfo.event) {
    analyticsObject.events = analyticsInfo.event;
  }
  
  if (_.has(analyticsInfo, 'agentLdap') && analyticsInfo.agentLdap) {
    analyticsObject.eVar1 = analyticsInfo.agentLdap;
  }
  
  if (_.has(analyticsInfo, 'customerGuid') && analyticsInfo.customerGuid) {
    analyticsObject.eVar2 = analyticsInfo.customerGuid;
  }
  
  if (_.has(analyticsInfo, 'customerCountryCode') && analyticsInfo.customerCountryCode) {
    analyticsObject.eVar4 = analyticsInfo.customerCountryCode;
  } 
  
  if (_.has(analyticsInfo, 'totalValue') && analyticsInfo.totalValue) {
    analyticsObject.eVar11 = analyticsInfo.totalValue;
  }
  
  if (_.has(analyticsInfo, 'currencyCode') && analyticsInfo.currencyCode) {
    analyticsObject.eVar12 = analyticsInfo.currencyCode;
  }

  if (_.has(analyticsInfo, 'errorReason') && analyticsInfo.errorReason) {
    analyticsObject.eVar151 = analyticsInfo.errorReason;
  }

  if (_.has(analyticsInfo, 'errorSystem') && analyticsInfo.errorSystem) {
    analyticsObject.eVar152 = analyticsInfo.errorSystem;
  }

  if (_.has(analyticsInfo, 'flowType') && analyticsInfo.flowType) {
    analyticsObject.eVar49 = analyticsInfo.flowType;
  }

  if (_.has(analyticsInfo, 'workFlowId') && analyticsInfo.workFlowId) {
    analyticsObject.eVar50 = analyticsInfo.workFlowId;
  }
  
  if (_.has(analyticsInfo, 'pageName') && analyticsInfo.pageName) {
    analyticsObject.pageName = analyticsInfo.pageName;
  }
  analyticsObject.t();
}

function getAnalyticsObjectByPage(analyticsInfo) {
  const analyticsObject = window.adobeAnalysticsObj;
  analyticsObject.clearVars();
  analyticsObject.eVar1 = _.has(analyticsInfo, 'agentLdap') && analyticsInfo.agentLdap ? analyticsInfo.agentLdap : '';
  analyticsObject.eVar2 = _.has(analyticsInfo, 'customerGuid') && analyticsInfo.customerGuid ? analyticsInfo.customerGuid : '';
  analyticsObject.eVar4 =
    _.has(analyticsInfo, 'customerCountryCode') && analyticsInfo.customerCountryCode ? analyticsInfo.customerCountryCode : '';
  analyticsObject.eVar22 = _.has(analyticsInfo, 'orderNumber') && analyticsInfo.orderNumber ? analyticsInfo.orderNumber : '';
  analyticsObject.eVar23 = _.has(analyticsInfo, 'offerType') && analyticsInfo.offerType ? analyticsInfo.offerType : '';
  analyticsObject.eVar24 =
    _.has(analyticsInfo, 'promoDiscountType') && analyticsInfo.promoDiscountType ? analyticsInfo.promoDiscountType : '';
  analyticsObject.eVar25 =
    _.has(analyticsInfo, 'cancelOfferType') && analyticsInfo.cancelOfferType ? analyticsInfo.cancelOfferType : '';
  analyticsObject.eVar49 = _.has(analyticsInfo, 'flowType') && analyticsInfo.flowType ? analyticsInfo.flowType : '';
  analyticsObject.eVar50 = _.has(analyticsInfo, 'workFlowId') && analyticsInfo.workFlowId ? analyticsInfo.workFlowId : '';
  analyticsObject.pageName = _.has(analyticsInfo, 'pageName') && analyticsInfo.pageName ? analyticsInfo.pageName : '';
  analyticsObject.t();
}

function getAnalyticsObjectByOrder(analyticsInfo, s) {
  const analyticsObject = window.adobeAnalysticsObj;
  analyticsObject.clearVars();
  analyticsObject.events = _.has(analyticsInfo, 'action') && analyticsInfo.action ? analyticsInfo.action : '';
  analyticsObject.purchaseID = _.has(analyticsInfo, 'purchaseID') && analyticsInfo.purchaseID ? analyticsInfo.purchaseID : '';
  analyticsObject.currencyCode = _.has(analyticsInfo, 'currencyCode') && analyticsInfo.currencyCode ? analyticsInfo.currencyCode : '';
  analyticsObject.pageName = _.has(analyticsInfo, 'pageName') && analyticsInfo.pageName ? analyticsInfo.pageName : '';
  analyticsObject.products = _.has(analyticsInfo, 'products') && analyticsInfo.products ? analyticsInfo.products : '';
  analyticsObject.eVar1 = _.has(analyticsInfo, 'agentLdap') && analyticsInfo.agentLdap ? analyticsInfo.agentLdap : '';
  analyticsObject.eVar2 = _.has(analyticsInfo, 'customerGuid') && analyticsInfo.customerGuid ? analyticsInfo.customerGuid : '';
  analyticsObject.eVar4 =
    _.has(analyticsInfo, 'customerCountryCode') && analyticsInfo.customerCountryCode ? analyticsInfo.customerCountryCode : '';
  analyticsObject.eVar11 = _.has(analyticsInfo, 'totalValue') && analyticsInfo.totalValue ? analyticsInfo.totalValue : '';
  analyticsObject.eVar12 = _.has(analyticsInfo, 'currencyCode') && analyticsInfo.currencyCode ? analyticsInfo.currencyCode : '';
  analyticsObject.eVar13 = _.has(analyticsInfo, 'orderCategory') && analyticsInfo.orderCategory ? analyticsInfo.orderCategory : '';
  analyticsObject.eVar14 = _.has(analyticsInfo, 'orderType') && analyticsInfo.orderType ? analyticsInfo.orderType : '';
  analyticsObject.eVar15 =
    _.has(analyticsInfo, 'internalOrderType') && analyticsInfo.internalOrderType ? analyticsInfo.internalOrderType : '';
  analyticsObject.eVar16 =
    _.has(analyticsInfo, 'paymentCategory') && analyticsInfo.paymentCategory ? analyticsInfo.paymentCategory : '';
  analyticsObject.eVar17 = _.has(analyticsInfo, 'paymentType') && analyticsInfo.paymentType ? analyticsInfo.paymentType : '';
  analyticsObject.eVar18 = _.has(analyticsInfo, 'paymentSource') && analyticsInfo.paymentSource ? analyticsInfo.paymentSource : '';
  analyticsObject.eVar19 = _.has(analyticsInfo, 'marketSegment') && analyticsInfo.marketSegment ? analyticsInfo.marketSegment : '';
  analyticsObject.eVar20 =
    _.has(analyticsInfo, 'ARROrderTotalWithoutTax') && analyticsInfo.ARROrderTotalWithoutTax
      ? analyticsInfo.ARROrderTotalWithoutTax
      : '';
  analyticsObject.eVar21 =
    _.has(analyticsInfo, 'ARROrderTotalWithTax') && analyticsInfo.ARROrderTotalWithTax ? analyticsInfo.ARROrderTotalWithTax : '';
  analyticsObject.eVar22 = _.has(analyticsInfo, 'orderNumber') && analyticsInfo.orderNumber ? analyticsInfo.orderNumber : '';
  analyticsObject.eVar23 = _.has(analyticsInfo, 'offerType') && analyticsInfo.offerType ? analyticsInfo.offerType : '';
  analyticsObject.eVar24 =
    _.has(analyticsInfo, 'promoDiscountType') && analyticsInfo.promoDiscountType ? analyticsInfo.promoDiscountType : '';
  analyticsObject.eVar49 = _.has(analyticsInfo, 'flowSubType') && analyticsInfo.flowSubType ? analyticsInfo.flowSubType : '';
  analyticsObject.eVar50 = _.has(analyticsInfo, 'flowType') && analyticsInfo.flowType ? analyticsInfo.flowType : '';
  analyticsObject.linkTrackEvents = 'events';
  if (analyticsInfo.arrTotalWithoutTax) {
    analyticsObject.events += `,event1=${analyticsInfo.arrTotalWithoutTax}`;
  }
  if (analyticsInfo.arrTotalWithTax) {
    analyticsObject.events += `,event2=${analyticsInfo.arrTotalWithTax}`;
  }
  if (analyticsInfo.ARROrderTotalWithoutTax) {
    analyticsObject.events += `,event3=${analyticsInfo.ARROrderTotalWithoutTax}`;
  }
  if (analyticsInfo.ARROrderTotalWithTax) {
    analyticsObject.events += `,event4=${analyticsInfo.ARROrderTotalWithTax}`;
  }
  analyticsObject.linkTrackVars =
    'purchaseID,event1,event2,event3,event4,currencyCode,pageName,products,eVar1,eVar2,eVar3,eVar4,eVar11,eVar12,eVar13,eVar14,eVar15,eVar16,eVar17,eVar18,eVar19,eVar20,eVar21,eVar22,eVar23,eVar24,eVar25,eVar49,eVar50';
  analyticsObject.tl();
}

export const trackOrderEvent = function (analyticsInfo) {
  if (analyticsAvailable()) {
    try {
      getAnalyticsObjectByOrder(analyticsInfo);
    } catch (e) {
    }
  }
};

export const getProductInfo = (productList) => {
  let productString = '';
  if (productList.length > 0) {
    productList.forEach(function (orderItem, key) {
      const productName = _.has(orderItem, 'productName') ? orderItem.productName : '';
      const productQnty = _.has(orderItem, 'quantity') ? orderItem.quantity : 0;
      let productPrice = _.has(orderItem, 'price.billable_items.price_details.unit_next_billing.amount_without_tax')
        ? orderItem.price.billable_items.price_details.unit_next_billing.amount_without_tax
        : 0;
      if (productPrice === 0) {
        productPrice = _.has(orderItem, 'price.billable_items.price_details.unit_next_billing.amount_with_tax')
          ? orderItem.price.billable_items.price_details.unit_next_billing.amount_with_tax
          : 0;
      }
      productString += `;${productName}`;
      productString += `;${productQnty}`;
      productString += `;${productPrice}`;
      if (productList.length > key + 1) {
        productString += ',';
      }
    });
  }
  return productString;
};

export const getArrAmount = (price, productCode, billingFrequency) => {
  price = parseFloat(price.replace(/,/g, ''));
  let arrAmount = 0;
  if (productCode === 'STEL') {
    arrAmount = parseFloat(price);
  } else if (billingFrequency === 'MONTHLY') {
    arrAmount = parseFloat(price) * 12;
  } else if (billingFrequency === 'ANNUAL') {
    arrAmount = parseFloat(price);
  } else {
    arrAmount = parseFloat(price);
  }
  return parseFloat(arrAmount.toFixed(2));
};

export const getMarketSeg = (marketSeg) => {
  if (marketSeg === 'COMMERCIAL') {
    return 'COM';
  } else if (marketSeg === 'EDUCATION') {
    return 'EDU';
  } else {
    return '';
  }
};

export const setAdobeAnalyticsDataForEventTracking = (analyticsData) => {
  const pageName = _.has(analyticsData, 'flowType') && analyticsData.flowType ? `${analyticsData.flowType}` : '';
  const workFlowId = _.has(analyticsData, 'featureName') && analyticsData.featureName ? analyticsData.featureName : '';
  const flowType = _.has(analyticsData, 'subFeatureName') && analyticsData.subFeatureName ? analyticsData.subFeatureName : '';
  const orderNumberFromData =
    analyticsData.orderNumber != null && String(analyticsData.orderNumber).trim() !== ''
      ? String(analyticsData.orderNumber).trim()
      : analyticsData.orderId != null && String(analyticsData.orderId).trim() !== ''
        ? String(analyticsData.orderId).trim()
        : '';
  const analysticsObj = {
    agentLdap: analyticsData.agentLdap || '',
    customerGuid: analyticsData.customerGuid || '',
    customerEmail: analyticsData.customerEmail || '',
    customerCountryCode: analyticsData.customerCountryCode || '',
    pageName: pageName || '',
    workFlowId: workFlowId || '',
    flowType: flowType || '',
    orderNumber: orderNumberFromData,
  };
  trackPageView(analysticsObj);
};

export const setAdobeAnalyticsDataForErrorEventTracking = (analyticsData) => {
  const pageName = _.has(analyticsData, 'flowType') && analyticsData.flowType ? `${analyticsData.flowType}` : '';
  const workFlowId = _.has(analyticsData, 'featureName') && analyticsData.featureName ? analyticsData.featureName : '';
  const flowType = _.has(analyticsData, 'subFeatureName') && analyticsData.subFeatureName ? analyticsData.subFeatureName : '';
  const analysticsObj = {
    event:analyticsData.errorEvent,
    agentLdap: analyticsData.agentLdap || '',
    customerGuid: analyticsData.customerGuid || '',
    customerCountryCode: analyticsData.customerCountryCode || '',
    errorReason: analyticsData.errorReason || '',
    errorSystem: analyticsData.errorSystem || '',
    pageName: pageName || '',
    workFlowId: workFlowId || '',
    flowType: flowType || ''
  };
  trackEvent(analysticsObj);
};

export const getCreditDebitMemoAnalysticPayload = (analysticsObj) => {
  const analystics = {
    agentLdap: analysticsObj.agentLdap,
    customerGuid: analysticsObj.customerGuid,
    customerEmail: analysticsObj.customerEmail,
    customerCountryCode: analysticsObj.customerCountryCode,
    flowType: analysticsObj.flowType,
    featureName: analysticsObj.featureName,
    subFeatureName: analysticsObj.flowSubType,
    cmDmAmount: 0
  };

  if (analysticsObj.cmPayload) {
    analystics.cmDmAmount = analysticsObj.cmPayload.order.header.total_bill_amount;
  }
  setAdobeAnalyticsDataForEventTracking(analystics);
};
